angular
  .module('contributor')

  .factory('VatCrud', [
    'Crud',

    function(Crud) {
      'use strict';

      class VatCrud extends Crud {
        constructor(list) {
          super(
            'vat' + (list || ''),
            '@@apiUrl' + '/vats' + (list || '') + '/:id',
            { id: '@id' },
            {
              query: {
                method: 'GET',
                isArray: true
              }
            }
          );
        }
      }

      return VatCrud;
    }
  ]);
